import React from "react";

import Context from "../../../context/Context";
import DropdownButton from "../../common/Dropdown/DropdownButton";
import Icons from "../../util/Icons";
import * as shareUtil from "./shareUtil";

export default class ShareDropdown extends React.Component {

  constructor(props) {
    super(props);
    this.copyClicked = this.copyClicked.bind(this);
    this.emailClicked = this.emailClicked.bind(this);
  }

  copyClicked(event) {
    const shareUrl = this.props.shareUrl;
    if (shareUrl) {
      const msg = Context.instance.i18n.infoPanel.messages.locationCopied;
      shareUtil.copyToClipboard(shareUrl,msg);
    }
  }

  emailClicked(event) {}

  render() {
    const i18n = Context.instance.i18n;
    const buttonContent = (
      <div>
        {Icons.share()}
        <span className={"i-actionbar-button-caption"}
          >{i18n.infoPanel.actions.share.caption}</span>
      </div>
    );
    const dropdownContent = this.renderDropdownMenu();
    return (
      <DropdownButton
        closeOnSelect={true}
        focusFirst={true}
        buttonClassName={"i-actionbar-button"}
        buttonContent={buttonContent}
        dropdownContent={dropdownContent}>
      </DropdownButton>
    );
  }

  renderDropdownMenu() {
    const mailto = (shareUtil.generateMailtoRef(this.props.shareUrl) || "#");
    const hashref = "#";
    const i18n = Context.instance.i18n;
    const menu = (
      <ul role="menu">
        <li key="share_email" role="none">
          <a className="i-dd-menuitem" href={mailto} tabIndex="0" target="_top"
            role="menuitem button" onClick={this.emailClicked}
            data-i--first={true}
            >{i18n.infoPanel.actions.share.email}</a>
        </li>
        <li key="share_copy" role="none">
          <a className="i-dd-menuitem" href={hashref} tabIndex="0"
            role="menuitem button" onClick={this.copyClicked}
            >{i18n.infoPanel.actions.share.copy}</a>
        </li>
      </ul>
    );
    return menu;
  }

}
